import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProcurementCosts from '../../components/ProcurementCosts';
import { Route } from 'react-router-dom';
import { PROCUREMENTCOST } from '../../routes';

const ProcurementCostsRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PROCUREMENTCOST}
				render={props => <ProcurementCosts {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProcurementCostsRoute;
